




























import Vue from 'vue'

export default Vue.extend({
  name: 'ExcCheckbox',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    id: {
      type: [String, Number],
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
  },
  computed: {
    compValue: {
      get (): boolean {
        return this.value
      },
      set (v: boolean): void {
        this.$emit('input', v)
      },
    },
  },
})
